// @flow
import React from "react";
import styled from "styled-components";

type Props = {|
    children: Object,
    className?: string,
    showIndicator: boolean,
|};

const Dot = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 100%;
    position: absolute;
    top: -2px;
    right: -3px;
    border-width: 1px;
    border-style: solid;
`;

const WithIndicator = ({
	children, className, showIndicator = false, ...props
} : Props) => (
	<div className={`${className || ""} relative`} {...props}>
		{children}
		{showIndicator && <Dot className="bg-link bc-window" />}
	</div>
);

export default WithIndicator;
